export default __webpack_public_path__ + "static/media/IMG-20241005-WA0026.42946f90.jpg";